import { z } from 'zod';

/**
 * The one pagination idiom for offset-paginated lists (M10 admin lists; `/me/bids` since the
 * post-M10 follow-ups): `?limit=&offset=` with a `{ items, total }` envelope. Chosen over keyset
 * (the digest-cursor precedent) because these are page-numbered UI datasets, and e.g. the sales
 * list orders by `startDate DESC` which would need a composite cursor. `total` comes from a
 * `COUNT(*)` twin of the page query's WHERE. Coerced: query-string values arrive as strings.
 */
export const paginationQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

/** `{ items, total }` envelope for a paginated list of `item`. */
export function paginatedSchema<T extends z.ZodType>(item: T) {
  return z.object({
    items: z.array(item),
    total: z.number().int().nonnegative(),
  });
}
